/**
 * Точка входа SPA Kaznacheistvo.
 *
 * Flow: монтирует App в #root. Роутинга пока нет — приложение состоит из
 * экрана входа и заглушки главного экрана; маршрутизатор появится вместе с
 * доменными экранами (сводный дашборд, источники, reconciliation).
 *
 * Зависимости:
 *   - react-dom/client: монтирование дерева компонентов;
 *   - App.jsx: корневой компонент.
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
